import { useContext } from 'react';
import { LeaguesContext } from '../contexts/leagues';

// ----------------------------------------------------------------------

const useLeagues = () => useContext(LeaguesContext);

export default useLeagues;
